import Vue from 'vue'
import Router from 'vue-router'
import ChatLayout from '@/Layouts/ChatLayout'
import HomeLayout from '@/Layouts/HomeLayout'
import ProfileLayout from '@/Layouts/ProfileLayout'
import LegalDocLayout from '@/Layouts/LegalDocumentLayout'
import TermsAndConditions from '@/LegalDocs/TermsAndConditions'
import PrivacyPolicy from '@/LegalDocs/PrivacyPolicy'

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomeLayout
        },
        {
            path: '/Chat',
            name: 'ChatLayout',
            component: ChatLayout
        },
        {
            path: '/Profile/:stringUrl',
            name: 'ProfileLayout',
            component: ProfileLayout
        },
        {
            path: '/Doc',
            name: 'LegalDocLayout',
            component: LegalDocLayout,
            children: [
                {
                    path: 'TOC',
                    name: 'TermsAndConditions',
                    component: TermsAndConditions,
                },
                {
                    path: 'PrivacyPolicy',
                    name: 'PrivacyPolicy',
                    component: PrivacyPolicy,
                }
            ]
        },
    ],
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/router.js